module.exports = __webpack_public_path__ + "static/media/iconstorage.ab132c49.svg";